import React from "react";

export const GraduateIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5913_51155)">
      <path
        d="M16.9219 6.37512C16.9219 7.68052 16.4033 8.93245 15.4803 9.8555C14.5572 10.7786 13.3053 11.2971 11.9999 11.2971C10.6945 11.2971 9.44256 10.7786 8.5195 9.8555C7.59645 8.93245 7.07788 7.68052 7.07788 6.37512V1.45312H16.9219V6.37512Z"
        stroke="#767676"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.85889 22.5454C2.88407 20.1377 3.85817 17.8373 5.56961 16.1436C7.28105 14.45 9.5916 13.5 11.9994 13.5C14.4072 13.5 16.7177 14.45 18.4292 16.1436C20.1406 17.8373 21.1147 20.1377 21.1399 22.5454"
        stroke="#767676"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.45288 1.45312H22.5469"
        stroke="#767676"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.07788 5.67188H16.9219"
        stroke="#767676"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.85889 1.45312V8.48413"
        stroke="#767676"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.32495 14.6924L12 18.3284L16.675 14.6914"
        stroke="#767676"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5913_51155">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SendIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.00004 11.999L3.26904 3.125C9.80185 5.02467 15.9624 8.02579 21.485 11.999C15.9628 15.9728 9.80262 18.9746 3.27004 20.875L6.00004 11.999ZM6.00004 11.999H13.5"
      stroke="#767676"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const StewpanIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5913_51127)">
      <path
        d="M4.26611 12.7031H19.7351V20.6721C19.7351 21.1694 19.5376 21.6463 19.1859 21.998C18.8343 22.3496 18.3574 22.5471 17.8601 22.5471H6.14111C5.64383 22.5471 5.16692 22.3496 4.81529 21.998C4.46366 21.6463 4.26611 21.1694 4.26611 20.6721V12.7031Z"
        stroke="#767676"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.7339 14.1094H22.5469"
        stroke="#767676"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.26588 14.1094H1.45288"
        stroke="#767676"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.26611 12.7034C4.26611 9.59637 7.72911 8.48438 12.0001 8.48438C16.2711 8.48438 19.7341 9.59637 19.7341 12.7034"
        stroke="#767676"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1089 18.3281H15.5149"
        stroke="#767676"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 5.67188V8.48488"
        stroke="#767676"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.328 1.45312C19.675 4.14613 16.311 3.68512 18.328 6.37512"
        stroke="#767676"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.63097 1.45312C6.97797 4.14613 3.61397 3.68512 5.63097 6.37512"
        stroke="#767676"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5913_51127">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LanguagesIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5913_51146)">
      <path
        d="M4.96899 8.48513V5.67213C4.96899 5.2991 5.11718 4.94135 5.38095 4.67758C5.64472 4.41381 6.00247 4.26563 6.37549 4.26562C6.74852 4.26563 7.10627 4.41381 7.37004 4.67758C7.63381 4.94135 7.78199 5.2991 7.78199 5.67213V8.48513"
        stroke="#767676"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.96899 7.07812H7.78199"
        stroke="#767676"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.219 10.5938V11.9998"
        stroke="#767676"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.406 12H19.031"
        stroke="#767676"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.625 12C17.625 12 16.219 16.219 13.406 16.219"
        stroke="#767676"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.219 14.5938C16.5326 15.0615 16.9492 15.4512 17.4368 15.7329C17.9244 16.0146 18.4701 16.1808 19.032 16.2188"
        stroke="#767676"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2971 18.3274C11.1125 18.3274 10.9296 18.291 10.7591 18.2203C10.5885 18.1497 10.4335 18.0461 10.3029 17.9156C10.1724 17.785 10.0688 17.63 9.99814 17.4594C9.92748 17.2888 9.89111 17.106 9.89111 16.9214V9.89037C9.89111 9.70574 9.92748 9.52291 9.99814 9.35232C10.0688 9.18174 10.1724 9.02674 10.3029 8.89618C10.4335 8.76562 10.5885 8.66206 10.7591 8.5914C10.9296 8.52074 11.1125 8.48438 11.2971 8.48438H21.1411C21.514 8.48438 21.8716 8.63251 22.1353 8.89618C22.399 9.15986 22.5471 9.51748 22.5471 9.89037V16.9214C22.5471 17.2943 22.399 17.6519 22.1353 17.9156C21.8716 18.1792 21.514 18.3274 21.1411 18.3274H19.7351V22.5464L15.5161 18.3274H11.2971Z"
        stroke="#767676"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.07788 12.7021L4.26488 15.5151V11.2961H2.85888C2.48599 11.2961 2.12836 11.148 1.86469 10.8843C1.60101 10.6206 1.45288 10.263 1.45288 9.89013V2.85912C1.45288 2.48623 1.60101 2.12861 1.86469 1.86493C2.12836 1.60126 2.48599 1.45313 2.85888 1.45312H12.7029C13.0758 1.45312 13.4334 1.60126 13.6971 1.86493C13.9607 2.12861 14.1089 2.48623 14.1089 2.85912V5.67212"
        stroke="#767676"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5913_51146">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CharacteristicsIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.1901 16.5118C18.5352 16.5186 18.8782 16.4565 19.1991 16.3291C19.5199 16.2017 19.8121 16.0116 20.0586 15.7699C20.305 15.5282 20.5008 15.2398 20.6345 14.9215C20.7682 14.6032 20.837 14.2615 20.837 13.9163C20.837 13.5711 20.7682 13.2294 20.6345 12.9111C20.5008 12.5928 20.305 12.3044 20.0586 12.0627C19.8121 11.8211 19.5199 11.631 19.1991 11.5036C18.8782 11.3762 18.5352 11.314 18.1901 11.3208C17.5105 11.3342 16.8633 11.6135 16.3874 12.0988C15.9116 12.5841 15.645 13.2366 15.645 13.9163C15.645 14.596 15.9116 15.2486 16.3874 15.7339C16.8633 16.2192 17.5105 16.4985 18.1901 16.5118Z"
      stroke="#767676"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1399 21.6672C14.1399 20.5931 14.5666 19.5629 15.3261 18.8034C16.0856 18.0439 17.1158 17.6172 18.1899 17.6172C19.264 17.6172 20.2942 18.0439 21.0537 18.8034C21.8132 19.5629 22.2399 20.5931 22.2399 21.6672H14.1399Z"
      stroke="#767676"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.07788 10.1992H14.1779"
      stroke="#767676"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.07788 13.5742H12.1529"
      stroke="#767676"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.07788 16.9492H12.1529"
      stroke="#767676"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0281 21.6758H3.37808C3.20079 21.6758 3.02524 21.6409 2.86145 21.573C2.69766 21.5052 2.54884 21.4057 2.42348 21.2804C2.29812 21.155 2.19868 21.0062 2.13084 20.8424C2.06299 20.6786 2.02808 20.5031 2.02808 20.3258V6.15078C2.02808 5.79274 2.17031 5.44936 2.42348 5.19619C2.67666 4.94301 3.02003 4.80078 3.37808 4.80078H6.75308C6.75308 3.90568 7.10866 3.04723 7.74159 2.4143C8.37453 1.78136 9.23297 1.42578 10.1281 1.42578C11.0232 1.42578 11.8816 1.78136 12.5146 2.4143C13.1475 3.04723 13.5031 3.90568 13.5031 4.80078H16.8781C17.2361 4.80078 17.5795 4.94301 17.8327 5.19619C18.0858 5.44936 18.2281 5.79274 18.2281 6.15078V8.62578"
      stroke="#767676"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.128 4.8C10.0385 4.8 9.95267 4.76444 9.88938 4.70115C9.82609 4.63785 9.79053 4.55201 9.79053 4.4625C9.79053 4.37299 9.82609 4.28714 9.88938 4.22385C9.95267 4.16056 10.0385 4.125 10.128 4.125"
      stroke="#767676"
      strokeWidth="1.5"
    />
    <path
      d="M10.1279 4.8C10.2174 4.8 10.3033 4.76444 10.3666 4.70115C10.4299 4.63785 10.4654 4.55201 10.4654 4.4625C10.4654 4.37299 10.4299 4.28714 10.3666 4.22385C10.3033 4.16056 10.2174 4.125 10.1279 4.125"
      stroke="#767676"
      strokeWidth="1.5"
    />
  </svg>
);
